module.exports = __webpack_public_path__ + "img/93.0cc5074f.jpg";